/*
  Cart discount codes — apply & remove via the Cart AJAX API (/cart/update.js).
  The `discount` parameter REPLACES the full set of codes, so:
    apply  -> current codes + new code
    remove -> current codes minus the removed code
    clear  -> ''
  After updating we re-render the cart drawer using the `sections` response
  (same pattern Dawn's cart-drawer.js uses).
*/
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function appliedCodes() {
    var el = document.querySelector('[data-applied-codes]');
    var raw = el ? el.getAttribute('data-applied-codes') || '' : '';
    return raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function setBusy(on) {
    var wrap = document.querySelector('.cart__discount');
    if (wrap) wrap.classList.toggle('is-busy', on);
  }

  function showError(msg) {
    var el = document.querySelector('[data-cart-discount-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function codeIsApplied(code) {
    var lc = code.toLowerCase();
    return Array.prototype.some.call(
      document.querySelectorAll('[data-cart-discount-remove]'),
      function (b) { return (b.getAttribute('data-cart-discount-remove') || '').toLowerCase() === lc; }
    );
  }

  function swapDrawer(state) {
    if (!state || !state.sections || !state.sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
    var next = doc.querySelector('#CartDrawer');
    var cur = document.querySelector('#CartDrawer');
    if (!next || !cur) return;
    cur.innerHTML = next.innerHTML;
    // Re-bind the overlay close handler that Dawn attaches in its constructor
    var drawerEl = cur.closest('cart-drawer');
    var overlay = cur.querySelector('#CartDrawer-Overlay');
    if (drawerEl && overlay && typeof drawerEl.close === 'function') {
      overlay.addEventListener('click', drawerEl.close.bind(drawerEl));
    }
  }

  function update(codes, enteredCode) {
    var body = new FormData();
    body.append('discount', codes.join(','));
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);
    setBusy(true);
    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body,
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        swapDrawer(state);
        var details = document.getElementById('Details-CartDrawer-Discount');
        if (details) details.setAttribute('open', '');
        if (enteredCode && !codeIsApplied(enteredCode)) {
          showError('Code “' + enteredCode + '” isn’t valid for this cart.');
        }
      })
      .catch(function () {
        showError('Something went wrong. Please try again.');
      })
      .finally(function () { setBusy(false); });
  }

  function applyFromInput() {
    var input = document.querySelector('[data-cart-discount-input]');
    var code = input ? input.value.trim() : '';
    showError('');
    if (!code) { if (input) input.focus(); return; }
    var codes = appliedCodes();
    if (codes.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) === -1) {
      codes.push(code);
    }
    update(codes, code);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-discount-apply]')) {
      e.preventDefault();
      applyFromInput();
      return;
    }
    var removeBtn = e.target.closest('[data-cart-discount-remove]');
    if (removeBtn) {
      e.preventDefault();
      var toRemove = (removeBtn.getAttribute('data-cart-discount-remove') || '').toLowerCase();
      var remaining = appliedCodes().filter(function (c) { return c.toLowerCase() !== toRemove; });
      showError('');
      update(remaining, null);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target.closest('[data-cart-discount-input]')) return;
    e.preventDefault();
    applyFromInput();
  });
})();
